// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"337":"050919ac3e5e8fd25086","641":"f8fb04320c2c951877ac","805":"7b2c70908cd83a184e3d","866":"72d810a250863402c5d1"}[chunkId] + ".js";
};